'use client';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { getProps } from './core.utils.js';
import { renderElem } from './render-element.util.js';
import { renderWithRef } from './render-with-ref.js';

function createComponent({ propTypes, displayName, root, propConfig, requiredStyleKeys = [], propKeysToRemove = propTypes ? Object.keys(propTypes) : null }) {
    return renderWithRef(displayName, propTypes, (userProps, ref)=>{
        useComponentStylesLoaded(displayName, requiredStyleKeys);
        const { props, wrapRoot, children, processedProps } = getProps(userProps, propConfig, propKeysToRemove);
        const rootElement = renderElem({
            root,
            ref,
            renderProps: processedProps,
            props,
            children
        });
        return wrapRoot ? wrapRoot(rootElement) : rootElement;
    });
}

export { createComponent };
